import { useTranslation } from "react-i18next";
import { DownloadFile } from "../../assets/svgs";
import "./styles.scss";
import { useLocation } from "react-router-dom";

const DownloadDocumentCard = ({ documentList, ...props }) => {
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const { t } = useTranslation();

  const handleDownload = async (fileObj) => {
    try {
      if (fileObj.url) {
        const link = document.createElement("a");
        link.href = fileObj.url;
        link.download = fileObj.filename || "document";
        link.target = "_blank";
        link.click();
        return;
      }

      if (fileObj.base64) {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${fileObj.base64}`;
        link.download = fileObj.filename || "document.pdf";
        link.click();
        return;
      }

      if (fileObj.documentId) {
        const response = await fetch(`/api/download/${fileObj.documentId}`);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileObj.filename || "document";
        link.click();

        window.URL.revokeObjectURL(url);
        return;
      }

      console.error("No valid download source found.");
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      {documentList &&
        documentList.map((doc) => (
          <div
            className="file-download-card"
            style={{ border: "1px solid #e3e8ef" }}
            {...props}
            key={doc.label}
          >
            <div className="left-section">
              <img src={DownloadFile} className="file-icon" alt="" />

              <div className="file-info">
                <p className="file-title">{t(`${routeName}.${doc.label}`)}</p>

                <div className="upload-meta">
                  <span
                    className="upload-text"
                    onClick={() => handleDownload(doc)}
                  >
                    {t(`${routeName}.click_to_download`)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default DownloadDocumentCard;
